import React, {FC, useState} from "react";
import {ModalFooter, useModalControls} from "@traas/lib/src/components/layout/ModalProvider";
import * as fa from "@fortawesome/free-solid-svg-icons";
import {SingleSelectCalendar} from "@traas/lib/src/components/form/MultiSelectCalendar";


export const PickDayModal: FC<{current: Date, onDaySelected: (d: Date) => void}> = (props) => {
  const [selected, setSelected] = useState<Date|null>(props.current)
  const confirm = async () => {
    if (selected) {
      props.onDaySelected(selected)
    }
  }

  return <form>
    <div className={"space-y-2"}>
      <SingleSelectCalendar taskDate={selected!} setSelected={setSelected} selected={selected} />
      <ModalFooter icon={fa.faSave} text={"Opslaan"} onSubmit={confirm}/>
    </div>
  </form>

}
